import NProgress from 'nprogress';
import router from './router';
import store from './store';
import 'nprogress/nprogress.css';

/**
 * 无token的情况
 * @param to
 * @param from
 * @param next
 */
function routeWithoutToken(to, from, next) {
    if (to.meta.auth === false) {
        // 不需要认证的直接跳转
        next();
    } else {
        // 无token时跳转到错误页
        next({
            path: '/error'
        });
    }
}

// 配置NProgress
NProgress.configure({ showSpinner: false });

// 使用全局路由守卫进行身份认证
router.beforeEach((to, from, next) => {
    // 开始进度条
    NProgress.start();

    if (store.state.user.token) {
        // 有token直接跳转
        next();
    } else {
        // 处理无token情况
        routeWithoutToken(to, from, next);
    }
});

// 全局路由守卫,只有next()调用才会触发守卫
router.afterEach(() => {
    // 路由跳转完成后关闭进度条
    NProgress.done();
});
